module.exports = __webpack_public_path__ + "img/Smartphone-icon.340792a3.png";